// A "Ducks"-style collection
// https://github.com/erikras/ducks-modular-redux

// Action Types
export const typePrefix = 'vra/legend/';
export const actions = [
  'DECREMENT_STEPS',
  'INCREMENT_STEPS',
  'SET_MAX_VALUE',
  'SET_MIN_VALUE',
  'SET_STEPS',
  'TOGGLE_EDIT_LEGEND'
].reduce((result, key) => { result[key] = `${typePrefix}${key}`; return result; }, {});

// Reducer

export default function reducer(
  state = {
    isEditLegendVisible: false,
    maxValue: null,
    minValue: null,
    steps: null
  },
  action = {}
) {
  switch (action.type) {
    case actions.DECREMENT_STEPS:
      return {
        ...state,
        steps: state.steps > 3 ? state.steps - 1 : 3
      };
    case actions.INCREMENT_STEPS:
      return {
        ...state,
        steps: state.steps < 12 ? state.steps + 1 : 12
      };
    case actions.SET_MAX_VALUE:
      return {
        ...state,
        maxValue: action.value
      };
    case actions.SET_MIN_VALUE:
      return {
        ...state,
        minValue: action.value
      };
    case actions.SET_STEPS:
      return {
        ...state,
        steps: action.value
      };
    case actions.TOGGLE_EDIT_LEGEND:
      return {
        ...state,
        isEditLegendVisible: !state.isEditLegendVisible
      };
    default:
      return state;
  }
}

// Action Creators

export function decrementSteps() {
  return {
    type: actions.DECREMENT_STEPS
  };
}
  
export function incrementSteps() {
  return {
    type: actions.INCREMENT_STEPS
  };
}
  
export function setMaxValue(value) {
  return {
    type: actions.SET_MAX_VALUE,
    value
  };
}
  
export function setMinValue(value) {
  return {
    type: actions.SET_MIN_VALUE,
    value
  };
}
  
export function setSteps(value) {
  return {
    type: actions.SET_STEPS,
    value
  };
}
  
export function toggleEditLegend() {
  return {
    type: actions.TOGGLE_EDIT_LEGEND
  };
}

export const toggleEditLegendOnExit = () => {
  return (dispatch, getState) => {
    const state = getState();

    if(state.legends.isEditLegendVisible) {
      dispatch(toggleEditLegend());
    }
  };
};
